import React from "react";
import { t } from "ttag";

import { CRMForm, FormType } from ".";
import { ButtonPrimary } from "../Clickables";
import { TextField } from "../Forms/Input";
import { FormLayout } from "./CRMForm";

import styles from "./forms.module.scss";

export const UnsubscribeCAForm = (props: FormLayout) => {
    return (
        <CRMForm
            layout={props.layout}
            type={FormType.UNSUBSCRIBE_CA}
            custom_submit_url={props.custom_submit_url}
        >
            {(disabled) => (
                <>
                    <TextField
                        label={t`To unsubscribe, please fill in your email below.`}
                        className={styles.input}
                        name="Email"
                        isRequired
                        type="email"
                    />
                    <div className={styles.submitContainer}>
                        <ButtonPrimary type="submit" disabled={disabled}>
                            {t`Submit`}
                        </ButtonPrimary>
                    </div>
                </>
            )}
        </CRMForm>
    );
};
